import React from "react";
import { NavLink } from "react-router-dom";

const LeaveSubNav = ({ role, handleSettingCurrentPage, hasManagedDept }) => {
    if (role === 'admin') {
        return (
            <ul>
                <li><NavLink to="leaves/my-leave" onClick={() => handleSettingCurrentPage('leaves')}>My Leaves</NavLink></li>
                <li><NavLink to="leaves/requests" onClick={() => handleSettingCurrentPage('leaves')}>Requests</NavLink></li>
                {hasManagedDept && (
                    <li><NavLink to="leaves/credits" onClick={() => handleSettingCurrentPage('leaves')}>Credits</NavLink></li>
                )}
            </ul>
        );
    }

    if (role === 'manager') {
        return (
            <ul>
                <li><NavLink to="leaves/my-leave" onClick={() => handleSettingCurrentPage('leaves')}>My Leaves</NavLink></li>
                <li><NavLink to="leaves/requests" onClick={() => handleSettingCurrentPage('leaves')}>Requests</NavLink></li>
                {hasManagedDept && (
                    <li><NavLink to="leaves/credits" onClick={() => handleSettingCurrentPage('leaves')}>Credits</NavLink></li>
                )}
            </ul>
        );
    }

    if (role === 'supervisor') {
        return (
            <ul>
                <li><NavLink to="leaves/my-leave" onClick={() => handleSettingCurrentPage('leaves')}>My Leaves</NavLink></li>
                <li><NavLink to="leaves/requests" onClick={() => handleSettingCurrentPage('leaves')}>Requests</NavLink></li>
            </ul>
        );
    }

    if (role === 'management') {
        return (
            <ul>
                <li><NavLink to="leaves/requests" onClick={() => handleSettingCurrentPage('leaves')}>Requests</NavLink></li>
            </ul>
        );
    }
    
    return null;
}

export default LeaveSubNav;
